<style scoped>
.iframe-sty {
    width: 100%;
    border: none;
    height: 600px;

}

.flow {
    background: #fff;
    padding-left: 20px;
    margin-top: 4px;
}

.pdt100 {
    padding-bottom: 100px !important;
}

.header {
    background: #fff;
    margin: 4px 0;
    font-size: 16px;
    text-align: center;
    line-height: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    padding: 0 16px;

}

.header .back {
    background: #FFFFFF;
    border: 1px solid rgba(217, 217, 217, 1);
    border-radius: 2px;
    width: 60px;
    height: 28px;
    line-height: 28px;
    font-size: 12px;
    cursor: pointer;
}

.import-title {
    text-align: left;
    background: #fff;
    padding: 10px 16px;
    font-size: 16px;
}

.import-title.second {
    margin-top: 4px;
}

.header .title {
    text-align: center;
    flex: 1;
}

.customer-information {
    background: #fff;
    padding-bottom: 15px;
}

.customer-information .sub-title {
    text-align: left;
    font-size: 14px;
    padding: 10px 16px;
}

.sub-operate-add {
    color: #4FA1A4;
    margin-left: 14px;
    cursor: pointer;

}

.customer-information .cols {
    background: #fff;
    display: flex;
    padding: 4px 16px;
    padding-left: 20px;
}

.customer-information .col-itms {
    display: flex;
    align-items: center;
    margin-left: 20px;
}

.customer-information .col-itms .title {
    width: 120px;
    text-align: right;
    margin-right: 16px;
}

.customer-information .col-itms.second {
    margin-left: 170px;
}

.customer-information .col-itms .title span {
    color: red;
}

.import-new-wrap {
    padding-bottom: 15px;
}

.import-new-wrap .import-step-tip {
    text-align: left;
    padding-left: 170px;

}

.import-new-wrap .col-itms {
    align-items: baseline;
}

.operte-btns {
    background: #fff;
    margin-top: 4px;
    display: flex;
    justify-content: center;
    padding: 25px 0;

}

.operte-btns .btn {
    padding: 5px 18px;
    border: 1px solid rgba(217, 217, 217, 1);
    border-radius: 2px;
    cursor: pointer;
    margin-right: 10px;

}

.operte-btns .btn.save {

    border: 1px solid rgba(79, 161, 164, 1);
    color: rgba(79, 161, 164, 1);
    cursor: pointer;
}

.operte-btns .btn.submit {
    border: 1px solid rgba(79, 161, 164, 1);
    background: rgba(79, 161, 164, 1);
    color: #fff;
    cursor: pointer;

}

.content-main-box {
    height: auto !important;
}

.search-wrap {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}

.search-wrap .input-search {
    width: 200px;
}
</style>

<template>
    <div class="project-edit" v-loading.fullscreen.lock="fullscreenLoading">
        <div class="header">
            <div class="back" @click="$router.go(-1)">返回</div>
            <div class="title">{{$route.query.guid?'编辑规则':'添加规则'}}</div>
        </div>
        <div class="import-title">基础信息</div>
        <div class="customer-information">
            <div class="cols">
                <div class="col-itms">
                    <div class="title"><span>*</span>应用公司</div>
                    <el-select  @change="handleCompany" clearable filterable v-model="form.tenantGuid" placeholder="请选择" filterable class="w300">
                        <el-option v-for="item in sendTenantList" :key="item.sendTenantGuid"    :label="item.sendTenantName" :value="item.sendTenantGuid">
                        </el-option>
                    </el-select>
                </div>
                <div class="col-itms second">
                    <div class="title"><span style="color:#fff;">*</span>应用部门</div>
                    <el-select  v-model="form.organisationGuid" placeholder="请选择" clearable filterable class="w300">
                        <el-option v-for="item in organisationList" :key="item.guid"  :label="item.organisationName" :value="item.guid"></el-option>
                    </el-select>
                  
                </div>
            </div>


            <div class="cols">
                <div class="col-itms ">
                    <div class="title"><span >*</span>停线原因</div>
                        <el-input class="w300" type="text" maxlength="10" placeholder="请填写"
                        v-model="form.stopReason"></el-input>
                </div>
                <div class="col-itms second">
                    <div class="title"><span>*</span>提示文案</div>
                    <el-input class="w300" type="text" maxlength="10" placeholder="请填写" v-model="form.tips"></el-input>
                </div>
            
            </div>
         
            <div class="cols" style="margin-top:10px;">
            <div class="col-itms">
                    <div class="title" ><span>*</span>是否需要回补</div>
                    <el-radio-group    v-model="form.isNeedMend">
                        <el-radio label="Y">需要</el-radio>
                        <el-radio label="N">不需要</el-radio>
                    </el-radio-group>
            </div>
            <div class="col-itms second" style="margin-left:324px">
                <div class="title"><span>*</span>界面排序</div>
                <el-input class="w300" v-model.number="form.orderNum" type="number" onkeyup="value=value.replace(/[^1-9]/g,'')" placeholder="请填写"></el-input>
            </div>
            </div>
          
            <div class="cols" style="margin-top:10px;">
            <div class="col-itms ">
                    <div class="title" ><span>*</span>是否限制次数</div>
                    <el-radio-group  @change="form.limitStopDays=''"  v-model="form.isLimitCount">
                        <el-radio label="N">不限制</el-radio>
                        <el-radio label="Y">限制 <template v-if="form.isLimitCount=='Y'">,每考核月最多停线<el-input onkeyup="value=value.replace(/[^\d.]/g, '')"  size="mini" style="width:70px;margin:0 6px;"  type="text" maxlength="2" placeholder="请填写" :disabled="form.isLimitCount=='N'" v-model="form.limitStopDays"></el-input>天</template></el-radio>
                    </el-radio-group>
                </div>
            </div>
        </div>
        <div class="operte-btns">
            <div class="btn cancel" @click="$router.go(-1)">取消</div>

            <div class="btn submit" @click="saveReq">确定</div>
        </div>
    </div>
</template>
<script>
export default {
    components: {
    },
    data() {
        return {
            fullscreenLoading:false,
            organisationList:[],
            sendTenantList: [],
            guid: '',
            form: {
                "tenantGuid":this.$route.query.tenantGuid||null,
                "organisationGuid":this.$route.query.organisationGuid||null,
                "guid":'',
                "stopReason":"",
                'limitStopDays':'',
                "isLimitCount":'N',
                "isNeedMend":'Y',
                "orderNum":""

            },

        }
    },
    watch: {

    },
    created() {
        this.getDetail();
        this.getSendTenantList();
    },
    methods: {
        handleCompany(val) {
            this.sendTenantList.forEach(item => {
                if (item.sendTenantGuid == val) {
                    this.form.organisationGuid = ''
                    this.getOrgList(val);
                }
            })
        },
        getSendTenantList() {
            let self = this;
            let query = {
                isService: true,
                tenantGuid: localStorage.guid,
            };
            self.api
                .get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`, query)
                .then((res) => {
                    if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                        self.sendTenantList = res.data.data;
                        if(this.$route.query.tenantGuid){
                          this.getOrgList(this.$route.query.tenantGuid)
                        }
                    } else {
                        self.$message.error(res.data.msg);
                    }
                });
        },
        getOrgList(tenantGuid) {
            let self = this;
            let query = {
                pageIndex: 1,
                pageSize: -1,
                tenantGuid:tenantGuid,
            };
            self.api.postJson(`/${serverConfig.msPersonnelService}/organisation/data/get`, query).then((res) => {
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                    self.organisationList = res.data.data.records;
                } else {
                    self.$message.error(res.data.msg);
                }
            });
        },
        getDetail() {
            let self = this;
            if(!this.$route.query.guid) return;
            self.api.get(`/${serverConfig.msConfigureService}/line-stop-rule/detail/${this.$route.query.guid}`).then((
                res) => {
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                    this.form = res.data.data;
                    this.getOrgList(this.form.tenantGuid)
                } else {
                    self.$message.error(res.data.msg);
                }
            });
        },
        checkForm() {
            if (!this.form.tenantGuid) {
                this.$message.error('应用公司不能为空')
                return false;
            }
            if (!this.form.stopReason) {
                this.$message.error('停线原因不能为空')
                return false;
            }
            if (!this.form.tips) {
                this.$message.error('具体原因提示文案不能为空')
                return false;
            }
            if (!this.form.tips) {
                this.$message.error('具体原因提示文案不能为空')
                return false;
            }
            if (!this.form.orderNum) {
                this.$message.error('界面排序不能为空')
                return false;
            }
            return true;
        },
        saveReq() {
            if (!this.checkForm()) return;
            let reqUrl = `/${serverConfig.msConfigureService}/line-stop-rule/add`
            let form = this.form;
            this.fullscreenLoading = true;
            if (!this.$route.query.guid) {
                this.api.postJson(reqUrl, form).then((res) => {
                    this.fullscreenLoading = false;
                    if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                        this.$message({
                            message: '新增成功',
                            type: 'success',
                        });
                        this.$router.go(-1);
                    } else {
                        this.$message.error(res.data.msg);
                    }
                });
            } else {
                reqUrl = `/${serverConfig.msConfigureService}/line-stop-rule/update`
                this.api.put(reqUrl, form).then((res) => {
                    this.fullscreenLoading = false;
                    if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {

                        this.$message({
                            message: '修改成功',
                            type: 'success',
                        });
                        this.$router.go(-1);
                    } else {
                        this.$message.error(res.data.msg);
                    }
                });

            }


        }
    }
};
</script> 